import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../ds';
import './bulkRefundsResults.scss';
import { getHostAppUrl } from '../../../Utils/environment';

const BulkRefundsResults = ({
  successRefunds = 0,
  errorsRefunds = 0,
  onDownloadResults,
}) => {
  const onGoBulkCancellations = () => {
    window.location.href = `${getHostAppUrl()}/refunds/bulk`;
  };

  return (
    <div className='k-ds-m-top-sp-04 k-ds-m-bottom-sp-05 bulk-refunds-results'>
      <div className='k-ds-heading-05'>Proceso terminado</div>
      <div className='bulk-refunds-results-card'>
        <div className='bulk-refunds-results-info'>
          <div className='k-ds-heading-01 k-ds-m-bottom-sp-02'>Resumen:</div>
          <table className='bulk-refunds-results-table'>
            <tbody>
              <tr className='bulk-refunds-results-row'>
                <td className='k-ds-heading-01 bulk-refunds-results-number'>
                  {successRefunds}
                </td>
                <td className='k-ds-body-01'>Completadas</td>
              </tr>
              <tr className='bulk-refunds-results-row'>
                <td className='k-ds-heading-01 bulk-refunds-results-number'>
                  {errorsRefunds}
                </td>
                <td className='k-ds-body-01'>No completadas</td>
                <td>
                  {errorsRefunds > 0 && (
                    <Button
                      type='link'
                      className='download-bulk-results-link'
                      onClick={onDownloadResults}
                    >
                      Revisar
                    </Button>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          <div className='bulk-refunds-results-divider' />
          <table>
            <tr className='bulk-refunds-results-row'>
              <td className='k-ds-heading-01 bulk-refunds-results-number'>
                {errorsRefunds + successRefunds}
              </td>
              <td className='k-ds-body-01'>Totales</td>
            </tr>
          </table>
        </div>
      </div>
      <div className='bulk-template-summary-action'>
        <Button
          size='large'
          className='bulk-template-summary-button'
          onClick={onGoBulkCancellations}
        >
          Ver cancelaciones masivas
        </Button>
      </div>
    </div>
  );
};

BulkRefundsResults.propTypes = {
  onDownloadResults: PropTypes.func,
  successRefunds: PropTypes.number,
  errorsRefunds: PropTypes.number,
};

export default BulkRefundsResults;
